// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about-page .menubar>header{box-shadow:none}.about-tab-container{padding:1rem 0.75rem}.about-tab-container p{line-height:1.3em}\n", ""]);
// Exports
module.exports = exports;
